import React from 'react'
import PropTypes from 'prop-types'
import { Box, Card, IconButton, Typography } from '@mui/material'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import ZoomOutIcon from '@mui/icons-material/ZoomOut'

/**
 * Floating zoom toolbar — matches the overlay style used in PdfViewer.
 * Position it inside a `position: relative` container.
 */
const FloatingZoomToolbar = ({ scale, minScale, maxScale, onZoomIn, onZoomOut, showPercent = false, bottom = '5%', children }) => (
  <Box
    sx={{
      display: 'block',
      position: 'absolute',
      bottom,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 10,
    }}
  >
    <Card variant="outlined">
      <Box display="flex" alignItems="center">
        <IconButton disabled={scale <= minScale} onClick={onZoomOut}>
          <ZoomOutIcon />
        </IconButton>
        {showPercent && (
          <Typography variant="body2" minWidth={52} textAlign="center">
            {Math.round(scale * 100)}%
          </Typography>
        )}
        <IconButton disabled={scale >= maxScale} onClick={onZoomIn}>
          <ZoomInIcon />
        </IconButton>
        {children}
      </Box>
    </Card>
  </Box>
)

FloatingZoomToolbar.propTypes = {
  scale: PropTypes.number.isRequired,
  minScale: PropTypes.number.isRequired,
  maxScale: PropTypes.number.isRequired,
  onZoomIn: PropTypes.func.isRequired,
  onZoomOut: PropTypes.func.isRequired,
  showPercent: PropTypes.bool,
  bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
}

export default FloatingZoomToolbar
